export const productsData = {
  // 女亞麻水洗長袖襯衫式洋裝
  4550723004206: {
    code: 4550723004206,
    name: '女亞麻水洗長袖襯衫式洋裝',
    description: '',
    price: '1,990',
    alt: '黑色',
  },
  4550723004268: {
    code: 4550723004268,
    name: '女亞麻水洗長袖襯衫式洋裝',
    description: '',
    price: '1,990',
    alt: '深橘',
  },
  4550723004329: {
    code: 4550723004329,
    name: '女亞麻水洗長袖襯衫式洋裝',
    description: '',
    price: '1,990',
    alt: '煙燻綠',
  },
  4550723004381: {
    code: 4550723004381,
    name: '女亞麻水洗長袖襯衫式洋裝',
    description: '',
    price: '1,990',
    alt: '灰銀直紋',
  },
  // 女亞麻水洗無袖洋裝
  4550723004688: {
    code: 4550723004688,
    name: '女亞麻水洗無袖洋裝',
    description: '',
    price: '1,990',
    alt: '黑色',
  },
  4550723004749: {
    code: 4550723004749,
    name: '女亞麻水洗無袖洋裝',
    description: '',
    price: '1,990',
    alt: '磚紅',
  },
  4550723004800: {
    code: 4550723004800,
    name: '女亞麻水洗無袖洋裝',
    description: '',
    price: '1,990',
    alt: '摩卡棕',
  },
  4550723004862: {
    code: 4550723004862,
    name: '女亞麻水洗無袖洋裝',
    description: '',
    price: '1,990',
    alt: '深棕',
  },
  // 女大麻混棉短袖洋裝
  4548076799276: {
    code: 4548076799276,
    name: '女大麻混棉短袖洋裝',
    description: '',
    price: '1,790',
    alt: '深灰',
  },
  4548076799351: {
    code: 4548076799351,
    name: '女大麻混棉短袖洋裝',
    description: '',
    price: '1,790',
    alt: '黑色',
  },
  4548076799412: {
    code: 4548076799412,
    name: '女大麻混棉短袖洋裝',
    description: '',
    price: '1,790',
    alt: '煙燻藍',
  },
  // 女亞麻水洗七分袖套衫
  4550723003728: {
    code: 4550723003728,
    name: '女亞麻水洗七分袖套衫',
    description: '',
    price: '1,390',
    alt: '白色',
  },
  4550723003780: {
    code: 4550723003780,
    name: '女亞麻水洗七分袖套衫',
    description: '',
    price: '1,390',
    alt: '黑色',
  },
  4550723003841: {
    code: 4550723003841,
    name: '女亞麻水洗七分袖套衫',
    description: '',
    price: '1,390',
    alt: '深橘直紋',
  },
  4550723003902: {
    code: 4550723003902,
    name: '女亞麻水洗七分袖套衫',
    description: '',
    price: '1,390',
    alt: '淺綠直紋',
  },
  // 女亞麻水洗短袖套衫
  4550723005586: {
    code: 4550723005586,
    name: '女亞麻水洗短袖套衫',
    description: '',
    price: '1,190',
    alt: '白色',
  },
  4550723005647: {
    code: 4550723005647,
    name: '女亞麻水洗短袖套衫',
    description: '',
    price: '1,190',
    alt: '黑色',
  },
  4550723005708: {
    code: 4550723005708,
    name: '女亞麻水洗短袖套衫',
    description: '',
    price: '1,190',
    alt: '柔白直紋',
  },
  4550723005760: {
    code: 4550723005760,
    name: '女亞麻水洗短袖套衫',
    description: '',
    price: '1,190',
    alt: '灰直紋',
  },
  4550723005821: {
    code: 4550723005821,
    name: '女亞麻水洗短袖套衫',
    description: '',
    price: '1,190',
    alt: '磚紅直紋',
  },
  // 女亞麻水洗標準領長袖襯衫
  4548076153788: {
    code: 4548076153788,
    name: '女亞麻水洗標準領長袖襯衫',
    description: '',
    price: '1,390',
    alt: '白色',
  },
  4548076154082: {
    code: 4548076154082,
    name: '女亞麻水洗標準領長袖襯衫',
    description: '',
    price: '1,390',
    alt: '墨灰',
  },
  4548076154143: {
    code: 4548076154143,
    name: '女亞麻水洗標準領長袖襯衫',
    description: '',
    price: '1,390',
    alt: '淺橘',
  },
  4548076154204: {
    code: 4548076154204,
    name: '女亞麻水洗標準領長袖襯衫',
    description: '',
    price: '1,390',
    alt: '淺綠',
  },
  4548076154266: {
    code: 4548076154266,
    name: '女亞麻水洗標準領長袖襯衫',
    description: '',
    price: '1,390',
    alt: '淺藍',
  },
  4548076154327: {
    code: 4548076154327,
    name: '女亞麻水洗標準領長袖襯衫',
    description: '',
    price: '1,390',
    alt: '象牙白直紋',
  },
  4548076154501: {
    code: 4548076154501,
    name: '女亞麻水洗標準領長袖襯衫',
    description: '',
    price: '1,390',
    alt: '淡藍直紋',
  },
  // 女大麻混斜紋織九分袖襯衫
  4550723006965: {
    code: 4550723006965,
    name: '女大麻混斜紋織九分袖襯衫',
    description: '',
    price: '1,390',
    alt: '象牙白',
  },
  4550723007023: {
    code: 4550723007023,
    name: '女大麻混斜紋織九分袖襯衫',
    description: '',
    price: '1,390',
    alt: '黑色',
  },
  // 女大麻混丹寧九分袖襯衫
  4550723007382: {
    code: 4550723007382,
    name: '女大麻混丹寧九分袖襯衫',
    description: '',
    price: '1,390',
    alt: '深藍',
  },
  // 女大麻混斜紋織西裝外套
  4548076813132: {
    code: 4548076813132,
    name: '女大麻混斜紋織西裝外套',
    description: '',
    price: '2,290',
    alt: '灰白',
  },
  4548076813200: {
    code: 4548076813200,
    name: '女大麻混斜紋織西裝外套',
    description: '',
    price: '2,290',
    alt: '淺米',
  },
  4548076813262: {
    code: 4548076813262,
    name: '女大麻混斜紋織西裝外套',
    description: '',
    price: '2,290',
    alt: '暗藍',
  },
  // 女亞麻水洗襯衫式外套
  4548076813682: {
    code: 4548076813682,
    name: '女亞麻水洗襯衫式外套',
    description: '',
    price: '1,790',
    alt: '墨灰',
  },
  4548076813743: {
    code: 4548076813743,
    name: '女亞麻水洗襯衫式外套',
    description: '',
    price: '1,790',
    alt: '黑色',
  },
  4548076813811: {
    code: 4548076813811,
    name: '女亞麻水洗襯衫式外套',
    description: '',
    price: '1,790',
    alt: '象牙白直紋',
  },
  // 女亞麻混鏤空編織寬版針織衫
  4550723000017: {
    code: 4550723000017,
    name: '女亞麻混鏤空編織寬版針織衫',
    description: '',
    price: '1,190',
    alt: '墨灰',
  },
  4550723000079: {
    code: 4550723000079,
    name: '女亞麻混鏤空編織寬版針織衫',
    description: '',
    price: '1,190',
    alt: '淺米',
  },
  4550723000130: {
    code: 4550723000130,
    name: '女亞麻混鏤空編織寬版針織衫',
    description: '',
    price: '1,190',
    alt: '煙燻綠',
  },
  // 女亞麻水洗舒適寬版褲
  4548076102953: {
    code: 4548076102953,
    name: '女亞麻水洗舒適寬版褲',
    description: '',
    price: '1,390',
    alt: '墨灰',
  },
  4548076103011: {
    code: 4548076103011,
    name: '女亞麻水洗舒適寬版褲',
    description: '',
    price: '1,390',
    alt: '黑色',
  },
  4548076103073: {
    code: 4548076103073,
    name: '女亞麻水洗舒適寬版褲',
    description: '',
    price: '1,390',
    alt: '原色',
  },
  4548076103158: {
    code: 4548076103158,
    name: '女亞麻水洗舒適寬版褲',
    description: '',
    price: '1,390',
    alt: '煙燻綠',
  },
  4548076103608: {
    code: 4548076103608,
    name: '女亞麻水洗舒適寬版褲',
    description: '',
    price: '1,390',
    alt: '煙燻藍',
  },
  4548076103660: {
    code: 4548076103660,
    name: '女亞麻水洗舒適寬版褲',
    description: '',
    price: '1,390',
    alt: '柔白直紋',
  },
  4548076103721: {
    code: 4548076103721,
    name: '女亞麻水洗舒適寬版褲',
    description: '',
    price: '1,390',
    alt: '灰直紋',
  },
  // 女大麻混斜紋織直筒褲
  4548076861621: {
    code: 4548076861621,
    name: '女大麻混斜紋織直筒褲',
    description: '',
    price: '1,390',
    alt: '黑色',
  },
  4548076861683: {
    code: 4548076861683,
    name: '女大麻混斜紋織直筒褲',
    description: '',
    price: '1,390',
    alt: '淺米',
  },
  // 女大麻混丹寧直筒褲
  4548076877639: {
    code: 4548076877639,
    name: '女大麻混丹寧直筒褲',
    description: '',
    price: '1,390',
    alt: '深藍',
  },
  // 女大麻混斜紋織五分褲
  4548076862703: {
    code: 4548076862703,
    name: '女大麻混斜紋織五分褲',
    description: '',
    price: '1,190',
    alt: '灰白',
  },
  4548076862765: {
    code: 4548076862765,
    name: '女大麻混斜紋織五分褲',
    description: '',
    price: '1,190',
    alt: '淺米',
  },
  4548076862826: {
    code: 4548076862826,
    name: '女大麻混斜紋織五分褲',
    description: '',
    price: '1,190',
    alt: '暗藍',
  },
  // 萊賽爾混麻寬簷帽
  4548076958314: {
    code: 4548076958314,
    name: '萊賽爾混麻寬簷帽',
    description: '',
    price: '790',
    alt: '黑色',
  },
  4548076958321: {
    code: 4548076958321,
    name: '萊賽爾混麻寬簷帽',
    description: '',
    price: '790',
    alt: '淺米',
  },
  // 萊賽爾混麻附口袋領巾
  4548076956402: {
    code: 4548076956402,
    name: '萊賽爾混麻附口袋領巾',
    description: '',
    price: '390',
    alt: '淺灰',
  },
  4548076956419: {
    code: 4548076956419,
    name: '萊賽爾混麻附口袋領巾',
    description: '',
    price: '390',
    alt: '黑色',
  },
  4548076956426: {
    code: 4548076956426,
    name: '萊賽爾混麻附口袋領巾',
    description: '',
    price: '390',
    alt: '淺米',
  },
  4548076956433: {
    code: 4548076956433,
    name: '萊賽爾混麻附口袋領巾',
    description: '',
    price: '390',
    alt: '淺橘',
  },
  4548076956457: {
    code: 4548076956457,
    name: '萊賽爾混麻附口袋領巾',
    description: '',
    price: '390',
    alt: '淺黃',
  },
  4548076956464: {
    code: 4548076956464,
    name: '萊賽爾混麻附口袋領巾',
    description: '',
    price: '390',
    alt: '淺綠',
  },
  4548076956488: {
    code: 4548076956488,
    name: '萊賽爾混麻附口袋領巾',
    description: '',
    price: '390',
    alt: '淺藍',
  },
  4548076956495: {
    code: 4548076956495,
    name: '萊賽爾混麻附口袋領巾',
    description: '',
    price: '390',
    alt: '淺米格紋',
  },
  4548076956501: {
    code: 4548076956501,
    name: '萊賽爾混麻附口袋領巾',
    description: '',
    price: '390',
    alt: '深藍格紋',
  },
  4548076861812: {
    code: 4548076861812,
    name: '女大麻混斜紋織圍裹裙',
    description: '',
    price: '1,390',
    alt: '黑色',
  },
  4550723000376: {
    code: 4550723000376,
    name: '女亞麻五分袖針織衫',
    description: '',
    price: '1,190',
    alt: '黑色',
  },
  4550723000437: {
    code: 4550723000437,
    name: '女亞麻五分袖針織衫',
    description: '',
    price: '1,190',
    alt: '淺米',
  },
  4550723000499: {
    code: 4550723000499,
    name: '女亞麻五分袖針織衫',
    description: '',
    price: '1,190',
    alt: '淺黃',
  },
  4550723000734: {
    code: 4550723000734,
    name: '女亞麻混鏤空編織V領開襟衫',
    description: '',
    price: '1,190',
    alt: '墨灰',
  },
  4550723000796: {
    code: 4550723000796,
    name: '女亞麻混鏤空編織V領開襟衫',
    description: '',
    price: '1,190',
    alt: '淺米',
  },
  4550723000857: {
    code: 4550723000857,
    name: '女亞麻混鏤空編織V領開襟衫',
    description: '',
    price: '1,190',
    alt: '棕色',
  },
  4550723001090: {
    code: 4550723001090,
    name: '女亞麻無袖針織衫',
    description: '',
    price: '990',
    alt: '黑色',
  },
  4550723001151: {
    code: 4550723001151,
    name: '女亞麻無袖針織衫',
    description: '',
    price: '990',
    alt: '淺米',
  },
  4550723001212: {
    code: 4550723001212,
    name: '女亞麻無袖針織衫',
    description: '',
    price: '990',
    alt: '煙燻橘',
  },
  4550723033701: {
    code: 4550723033701,
    name: '女亞麻水洗短褲',
    description: '',
    price: '990',
    alt: '黑色',
  },
  4550723033763: {
    code: 4550723033763,
    name: '女亞麻水洗短褲',
    description: '',
    price: '990',
    alt: '原色',
  },
  4550723033824: {
    code: 4550723033824,
    name: '女亞麻水洗短褲',
    description: '',
    price: '990',
    alt: '煙燻綠',
  },
  4550723033886: {
    code: 4550723033886,
    name: '女亞麻水洗短褲',
    description: '',
    price: '990',
    alt: '煙燻藍',
  },
  4548076807049: {
    code: 4548076807049,
    name: '女大麻混斜紋織吊帶裙',
    description: '',
    price: '1,790',
    alt: '黑色',
  },
  4548076807100: {
    code: 4548076807100,
    name: '女大麻混斜紋織吊帶裙',
    description: '',
    price: '1,790',
    alt: '淺米',
  },
  4548076803799: {
    code: 4548076803799,
    name: '女大麻混棉細肩帶洋裝',
    description: '',
    price: '1,790',
    alt: '深灰',
  },
  4548076803881: {
    code: 4548076803881,
    name: '女大麻混棉細肩帶洋裝',
    description: '',
    price: '1,790',
    alt: '黑色',
  },
  4548076803942: {
    code: 4548076803942,
    name: '女大麻混棉細肩帶洋裝',
    description: '',
    price: '1,790',
    alt: '煙燻藍直紋',
  },
  4548076753810: {
    code: 4548076753810,
    name: '男亞麻混長袖針織襯衫式開襟衫',
    description: '',
    price: '1,590',
    alt: '墨灰',
  },
  4548076753872: {
    code: 4548076753872,
    name: '男亞麻混長袖針織襯衫式開襟衫',
    description: '',
    price: '1,590',
    alt: '黑色',
  },
  4548076753933: {
    code: 4548076753933,
    name: '男亞麻混長袖針織襯衫式開襟衫',
    description: '',
    price: '1,590',
    alt: '米黃',
  },
  4548076755203: {
    code: 4548076755203,
    name: '男亞麻混圓領短袖針織衫',
    description: '',
    price: '1,190',
    alt: '黑色',
  },
  4548076755272: {
    code: 4548076755272,
    name: '男亞麻混圓領短袖針織衫',
    description: '',
    price: '1,190',
    alt: '米黃',
  },
  4548076755333: {
    code: 4548076755333,
    name: '男亞麻混圓領短袖針織衫',
    description: '',
    price: '1,190',
    alt: '深藍',
  },
  4548076755395: {
    code: 4548076755395,
    name: '男亞麻混圓領短袖針織衫',
    description: '',
    price: '1,190',
    alt: '深摩卡棕',
  },
  4548076087076: {
    code: 4548076087076,
    name: '男亞麻水洗立領長袖襯衫',
    description: '',
    price: '1,390',
    alt: '白色',
  },
  4548076087137: {
    code: 4548076087137,
    name: '男亞麻水洗立領長袖襯衫',
    description: '',
    price: '1,390',
    alt: '原色',
  },
  4548076087199: {
    code: 4548076087199,
    name: '男亞麻水洗立領長袖襯衫',
    description: '',
    price: '1,390',
    alt: '淺藍',
  },
  4548076087250: {
    code: 4548076087250,
    name: '男亞麻水洗立領長袖襯衫',
    description: '',
    price: '1,390',
    alt: '深藍',
  },
  4548076087342: {
    code: 4548076087342,
    name: '男亞麻水洗立領長袖襯衫',
    description: '',
    price: '1,390',
    alt: '墨灰格紋',
  },
  4548076087403: {
    code: 4548076087403,
    name: '男亞麻水洗立領長袖襯衫',
    description: '',
    price: '1,390',
    alt: '深棕格紋',
  },
  4548076088271: {
    code: 4548076088271,
    name: '男亞麻水洗長袖襯衫',
    description: '',
    price: '1,590',
    alt: '白色',
  },
  4548076088332: {
    code: 4548076088332,
    name: '男亞麻水洗長袖襯衫',
    description: '',
    price: '1,590',
    alt: '原色',
  },
  4548076088394: {
    code: 4548076088394,
    name: '男亞麻水洗長袖襯衫',
    description: '',
    price: '1,590',
    alt: '淺藍',
  },
  4548076088547: {
    code: 4548076088547,
    name: '男亞麻水洗長袖襯衫',
    description: '',
    price: '1,590',
    alt: '深藍',
  },
  4548076088608: {
    code: 4548076088608,
    name: '男亞麻水洗長袖襯衫',
    description: '',
    price: '1,590',
    alt: '灰直紋',
  },
  4548076088660: {
    code: 4548076088660,
    name: '男亞麻水洗長袖襯衫',
    description: '',
    price: '1,590',
    alt: '卡其綠直紋',
  },
  4548076089117: {
    code: 4548076089117,
    name: '男亞麻水洗短袖襯衫',
    description: '',
    price: '1,190',
    alt: '白色',
  },
  4548076089209: {
    code: 4548076089209,
    name: '男亞麻水洗短袖襯衫',
    description: '',
    price: '1,190',
    alt: '原色',
  },
  4548076089261: {
    code: 4548076089261,
    name: '男亞麻水洗短袖襯衫',
    description: '',
    price: '1,190',
    alt: '淺藍',
  },
  4548076089353: {
    code: 4548076089353,
    name: '男亞麻水洗短袖襯衫',
    description: '',
    price: '1,190',
    alt: '深藍',
  },
  4548076069768: {
    code: 4548076069768,
    name: '男亞麻水洗外套',
    description: '',
    price: '2,290',
    alt: '黑色',
  },
  4548076069829: {
    code: 4548076069829,
    name: '男亞麻水洗外套',
    description: '',
    price: '2,290',
    alt: '原色',
  },
  4548076069881: {
    code: 4548076069881,
    name: '男亞麻水洗外套',
    description: '',
    price: '2,290',
    alt: '深藍',
  },
  4548076128182: {
    code: 4548076128182,
    name: '男亞麻水洗錐形褲',
    description: '',
    price: '1,590',
    alt: '黑色',
  },
  4548076128243: {
    code: 4548076128243,
    name: '男亞麻水洗錐形褲',
    description: '',
    price: '1,590',
    alt: '原色',
  },
  4548076128304: {
    code: 4548076128304,
    name: '男亞麻水洗錐形褲',
    description: '',
    price: '1,590',
    alt: '深藍',
  },
  4548076128861: {
    code: 4548076128861,
    name: '男大麻混棉斜紋織直筒褲',
    description: '',
    price: '1,190',
    alt: '黑色',
  },
  4548076128922: {
    code: 4548076128922,
    name: '男大麻混棉斜紋織直筒褲',
    description: '',
    price: '1,190',
    alt: '煙燻綠',
  },
  4548076128984: {
    code: 4548076128984,
    name: '男大麻混棉斜紋織直筒褲',
    description: '',
    price: '1,190',
    alt: '墨灰',
  },
  4548076895466: {
    code: 4548076895466,
    name: '男大麻混丹寧直筒褲',
    description: '',
    price: '1,190',
    alt: '暗藍',
  },
};

export const womenLinenData = [
  {
    id: 1,
    name: 'onePiece',
    heading: '洋裝',
    items: [
      {
        id: 1,
        pickup: {
          align: 'left',
          main: 'onePiece',
          note: '模特兒身高：168cm／穿著L尺寸<br />※未標示的商品僅為拍攝搭配參考商品。',
          products: [
            {
              id: 1,
              current_index: 3,
              no_chips: false,
              tag: '',
              items: ['4550723004206', '4550723004268', '4550723004329', '4550723004381'],
            },
          ],
          sub: ['onePiece-sub1', 'onePiece-sub2'],
        },
        other: {
          heading: '其他款洋裝',
          products: [
            {
              id: 1,
              current_index: 1,
              no_chips: false,
              tag: '',
              items: ['4550723004688', '4550723004749', '4550723004800', '4550723004862'],
            },
            {
              id: 2,
              current_index: 2,
              no_chips: false,
              tag: '',
              items: ['4548076799276', '4548076799351', '4548076799412'],
            },
            {
              id: 3,
              current_index: 2,
              no_chips: false,
              tag: '',
              items: ['4548076803799', '4548076803881', '4548076803942'],
            },
          ],
        },
        snap: [
          {
            id: 1,
            name: '女亞麻水洗長袖襯衫式洋裝',
            number: '7522402',
            modelInfo: '模特身高：173cm／穿著M尺寸',
          },
          {
            id: 2,
            name: '女亞麻水洗無袖洋裝',
            number: '7522321',
            modelInfo: '模特身高：166cm／穿著M尺寸',
          },
        ],
      },
    ],
  },
  {
    id: 2,
    name: 'shirt',
    heading: '襯衫・上衣',
    items: [
      {
        id: 1,
        pickup: {
          align: 'right',
          main: 'blouse',
          note: '模特兒身高：167cm／穿著M尺寸<br />※未標示的商品僅為拍攝搭配參考商品。',
          products: [
            {
              id: 1,
              current_index: 2,
              no_chips: false,
              tag: '',
              items: ['4550723003728', '4550723003780', '4550723003841', '4550723003902'],
            },
          ],
          sub: ['blouse-sub1', 'blouse-sub2'],
        },
        snap: [
          {
            id: 1,
            name: '女亞麻水洗七分袖套衫',
            number: '7522323',
            modelInfo: '模特身高：166cm／穿著M尺寸',
          },
        ],
      },
      {
        id: 2,
        pickup: {
          align: 'left',
          main: 'blouse2',
          note: '模特兒身高：167cm／穿著M尺寸<br />※未標示的商品僅為拍攝搭配參考商品。',
          products: [
            {
              id: 1,
              current_index: 0,
              no_chips: false,
              tag: '',
              items: ['4550723005586', '4550723005647', '4550723005708', '4550723005760', '4550723005821'],
            },
          ],
          sub: ['blouse2-sub1', 'blouse2-sub2'],
        },
        snap: [
          {
            id: 1,
            name: '女亞麻水洗短袖套衫',
            number: '7522326',
            modelInfo: '模特身高：160cm／穿著M尺寸',
          },
          {
            id: 2,
            name: '女亞麻水洗短袖套衫',
            number: '7522398',
            modelInfo: '模特身高：167cm／穿著M尺寸',
          },
        ],
      },
      {
        id: 3,
        pickup: {
          align: 'right',
          main: 'shirt',
          note: '模特兒身高：167cm／穿著M尺寸<br />※未標示的商品僅為拍攝搭配參考商品。',
          products: [
            {
              id: 1,
              current_index: 4,
              no_chips: false,
              tag: '',
              items: [
                '4548076153788',
                '4548076154082',
                '4548076154143',
                '4548076154204',
                '4548076154266',
                '4548076154327',
                '4548076154501',
              ],
            },
          ],
          sub: ['shirt-sub1', 'shirt-sub2'],
        },
        other: {
          heading: '其他款襯衫',
          products: [
            {
              id: 1,
              current_index: 0,
              no_chips: false,
              tag: '',
              items: ['4550723006965', '4550723007023'],
            },
            {
              id: 2,
              current_index: 0,
              no_chips: false,
              tag: '',
              items: ['4550723007382'],
            },
          ],
        },
        snap: [
          {
            id: 1,
            name: '女亞麻水洗標準領長袖襯衫',
            number: '7522324',
            modelInfo: '模特身高：166cm／穿著M尺寸',
          },
          {
            id: 2,
            name: '女亞麻水洗標準領長袖襯衫',
            number: '7522325',
            modelInfo: '模特身高：166cm／穿著M尺寸',
          },
          {
            id: 3,
            name: '女亞麻水洗標準領長袖襯衫',
            number: '7522356',
            modelInfo: '模特身高：160cm／穿著M尺寸',
          },
          {
            id: 4,
            name: '女亞麻水洗標準領長袖襯衫',
            number: '7522401',
            modelInfo: '模特身高：173cm／穿著M尺寸',
          },
          {
            id: 5,
            name: '女亞麻水洗標準領長袖襯衫',
            number: '7522399',
            modelInfo: '模特身高：167cm／穿著M尺寸',
          },
        ],
      },
    ],
  },
  {
    id: 3,
    name: 'outer',
    heading: '外套',
    items: [
      {
        id: 1,
        pickup: {
          align: 'left',
          main: 'outer',
          note: '模特兒身高：170cm／穿著M尺寸<br />※未標示的商品僅為拍攝搭配參考商品。',
          products: [
            {
              id: 1,
              current_index: 0,
              no_chips: false,
              tag: '',
              items: ['4548076813132', '4548076813200', '4548076813262'],
            },
          ],
          sub: ['outer-sub1', 'outer-sub2'],
        },
        other: {
          heading: '其他款外套',
          products: [
            {
              id: 1,
              current_index: 2,
              no_chips: false,
              tag: '',
              items: ['4548076813682', '4548076813743', '4548076813811'],
            },
          ],
        },
        snap: [
          {
            id: 1,
            name: '女大麻混斜紋織西裝外套',
            number: '7522339',
            modelInfo: '模特身高：167cm／穿著M尺寸',
          },
        ],
      },
    ],
  },
  {
    id: 4,
    name: 'cardigan',
    heading: '開襟衫・針織衫',
    items: [
      {
        id: 1,
        pickup: {
          align: 'right',
          main: 'sweater',
          note: '模特兒身高：167cm／穿著M尺寸<br />※未標示的商品僅為拍攝搭配參考商品。',
          products: [
            {
              id: 1,
              current_index: 1,
              no_chips: false,
              tag: '',
              items: ['4550723000017', '4550723000079', '4550723000130'],
            },
          ],
          sub: ['sweater-sub1', 'sweater-sub2'],
        },
        other: {
          heading: '其他款開襟衫・針織衫',
          products: [
            {
              id: 1,
              current_index: 0,
              no_chips: false,
              tag: '',
              items: ['4550723000376', '4550723000437', '4550723000499'],
            },
            {
              id: 2,
              current_index: 0,
              no_chips: false,
              tag: '',
              items: ['4550723000734', '4550723000796', '4550723000857'],
            },
            {
              id: 3,
              current_index: 0,
              no_chips: false,
              tag: '',
              items: ['4550723001090', '4550723001151', '4550723001212'],
            },
          ],
        },
        snap: [
          {
            id: 1,
            name: '女亞麻混鏤空編織寬版針織衫',
            number: '7522355',
            modelInfo: '模特身高：160cm／穿著M尺寸',
          },
          {
            id: 2,
            name: '女亞麻混鏤空編織寬版針織衫',
            number: '7522401',
            modelInfo: '模特身高：173cm／穿著M尺寸',
          },
          {
            id: 3,
            name: '女亞麻混鏤空編織寬版針織衫',
            number: '7522397',
            modelInfo: '模特身高：167cm／穿著M尺寸',
          },
        ],
      },
    ],
  },
  {
    id: 5,
    name: 'pants',
    heading: '褲子・裙子',
    items: [
      {
        id: 1,
        pickup: {
          align: 'left',
          main: 'pants',
          note: '模特兒身高：168cm／穿著L尺寸<br />※未標示的商品僅為拍攝搭配參考商品。',
          products: [
            {
              id: 1,
              current_index: 0,
              no_chips: false,
              tag: '',
              items: [
                '4548076102953',
                '4548076103011',
                '4548076103073',
                '4548076103158',
                '4548076103608',
                '4548076103660',
                '4548076103721',
              ],
            },
          ],
          sub: ['pants-sub1', 'pants-sub2'],
        },
        other: {
          heading: '其他款褲子',
          products: [
            {
              id: 1,
              current_index: 1,
              no_chips: false,
              tag: '',
              items: ['4548076861621', '4548076861683'],
            },
            {
              id: 2,
              current_index: 0,
              no_chips: false,
              tag: '',
              items: ['4548076877639'],
            },
            {
              id: 3,
              current_index: 1,
              no_chips: false,
              tag: '',
              items: ['4548076862703', '4548076862765', '4548076862826'],
            },
            {
              id: 4,
              current_index: 0,
              no_chips: false,
              tag: '',
              items: ['4550723033701', '4550723033763', '4550723033824', '4550723033886'],
            },
            {
              id: 5,
              current_index: 0,
              no_chips: false,
              tag: '',
              items: ['4548076807049', '4548076807100'],
            },
          ],
        },
        snap: [
          {
            id: 1,
            name: '女大麻混斜紋織直筒褲',
            number: '7522321',
            modelInfo: '模特身高：166cm／穿著M尺寸',
          },
          {
            id: 2,
            name: '女大麻混斜紋織直筒褲',
            number: '7522244',
            modelInfo: '模特身高：183cm／穿著M尺寸',
          },
          {
            id: 3,
            name: '女大麻混斜紋織直筒褲',
            number: '7522227',
            modelInfo: '模特身高：183cm／穿著M尺寸',
          },
          {
            id: 4,
            name: '女大麻混斜紋織五分褲',
            number: '7522339',
            modelInfo: '模特身高：166cm／穿著M尺寸',
          },
          {
            id: 5,
            name: '女大麻混斜紋織五分褲',
            number: '7522399',
            modelInfo: '模特身高：167cm／穿著M尺寸',
          },
          {
            id: 6,
            name: '女亞麻水洗舒適寬版褲',
            number: '7522355',
            modelInfo: '模特身高：160cm／穿著M尺寸',
          },
          {
            id: 7,
            name: '女亞麻水洗舒適寬版褲',
            number: '7522403',
            modelInfo: '模特身高：173cm／穿著M尺寸',
          },
          {
            id: 8,
            name: '女亞麻水洗舒適寬版褲',
            number: '7522402',
            modelInfo: '模特身高：173cm／穿著M尺寸',
          },
          {
            id: 9,
            name: '女亞麻水洗舒適寬版褲',
            number: '7522401',
            modelInfo: '模特身高：173cm／穿著M尺寸',
          },
          {
            id: 10,
            name: '女亞麻水洗舒適寬版褲',
            number: '7522398',
            modelInfo: '模特身高：167cm／穿著M尺寸',
          },
          {
            id: 11,
            name: '女大麻混丹寧直筒褲',
            number: '7522325',
            modelInfo: '模特身高：166cm／穿著M尺寸',
          },
        ],
      },
    ],
  },
  {
    id: 6,
    name: 'goods',
    heading: '帽子・圍巾',
    items: [
      {
        id: 1,
        pickup: {
          align: 'right',
          main: 'hat',
          note: '※未標示的商品僅為拍攝搭配參考商品。',
          products: [
            {
              id: 1,
              current_index: 1,
              no_chips: false,
              tag: '',
              items: ['4548076958314', '4548076958321'],
            },
          ],
          sub: ['hat-sub1', 'hat-sub2'],
        },
      },
      {
        id: 2,
        pickup: {
          align: 'left',
          main: 'scarf',
          note: '※未標示的商品僅為拍攝搭配參考商品。',
          products: [
            {
              id: 1,
              current_index: 0,
              no_chips: false,
              tag: '',
              note: '※販售實體門市：<a href="https://shop.muji.tw/Shop/StoreDetail/41566/37642" target="_blank">巨城門市</a>、<a href="https://shop.muji.tw/Shop/StoreDetail/41566/37216" target="_blank">松高門市</a>、<a href="https://shop.muji.tw/Shop/StoreDetail/41566/41672" target="_blank">MOP林口門市</a>',
              items: [
                '4548076956402',
                '4548076956419',
                '4548076956426',
                '4548076956433',
                '4548076956457',
                '4548076956464',
                '4548076956488',
                '4548076956495',
                '4548076956501',
              ],
            },
          ],
          sub: ['scarf-sub1', 'scarf-sub2'],
        },
      },
    ],
  },
];

export const womenLineupData = {
  products: [
    {
      id: 1,
      current_index: 1,
      no_chips: false,
      tag: '',
      items: ['4548076813132', '4548076813200', '4548076813262'],
    },
    {
      id: 2,
      current_index: 1,
      no_chips: false,
      tag: '',
      items: ['4548076813682', '4548076813743', '4548076813811'],
    },
    {
      id: 3,
      current_index: 1,
      no_chips: false,
      tag: '',
      items: ['4550723004206', '4550723004268', '4550723004329', '4550723004381'],
    },
    {
      id: 4,
      current_index: 1,
      no_chips: false,
      tag: '',
      items: ['4550723004688', '4550723004749', '4550723004800', '4550723004862'],
    },
    {
      id: 5,
      current_index: 1,
      no_chips: false,
      tag: '',
      items: ['4548076799276', '4548076799351', '4548076799412'],
    },
    {
      id: 6,
      current_index: 1,
      no_chips: false,
      tag: '',
      items: ['4550723003728', '4550723003780', '4550723003841', '4550723003902'],
    },
    {
      id: 7,
      current_index: 1,
      no_chips: false,
      tag: '',
      items: ['4550723005586', '4550723005647', '4550723005708', '4550723005760', '4550723005821'],
    },
    {
      id: 8,
      current_index: 1,
      no_chips: false,
      tag: '',
      items: [
        '4548076153788',
        '4548076154082',
        '4548076154143',
        '4548076154204',
        '4548076154266',
        '4548076154327',
        '4548076154501',
      ],
    },
    {
      id: 9,
      current_index: 1,
      no_chips: false,
      tag: '',
      items: ['4550723006965', '4550723007023'],
    },
    {
      id: 10,
      current_index: 0,
      no_chips: false,
      tag: '',
      items: ['4550723007382'],
    },
    {
      id: 11,
      current_index: 0,
      no_chips: false,
      tag: '',
      items: ['4550723000017', '4550723000079', '4550723000130'],
    },
    {
      id: 12,
      current_index: 0,
      no_chips: false,
      tag: '',
      items: [
        '4548076102953',
        '4548076103011',
        '4548076103073',
        '4548076103158',
        '4548076103608',
        '4548076103660',
        '4548076103721',
      ],
    },
    {
      id: 13,
      current_index: 0,
      no_chips: false,
      tag: '',
      items: ['4548076861621', '4548076861683'],
    },
    {
      id: 14,
      current_index: 0,
      no_chips: false,
      tag: '',
      items: ['4548076877639'],
    },
    {
      id: 15,
      current_index: 0,
      no_chips: false,
      tag: '',
      items: ['4548076862703', '4548076862765', '4548076862826'],
    },
    {
      id: 16,
      current_index: 0,
      no_chips: false,
      tag: '',
      items: ['4548076958314', '4548076958321'],
    },
    {
      id: 17,
      current_index: 0,
      no_chips: false,
      tag: '',
      items: [
        '4548076956402',
        '4548076956419',
        '4548076956426',
        '4548076956433',
        '4548076956457',
        '4548076956464',
        '4548076956488',
        '4548076956495',
        '4548076956501',
      ],
    },
    {
      id: 18,
      current_index: 0,
      no_chips: false,
      tag: '',
      items: ['4548076861812'],
    },
  ],
};

export const menLinenData = [
  {
    id: 1,
    name: 'shirt',
    heading: '襯衫',
    items: [
      {
        id: 1,
        pickup: {
          align: 'left',
          main: 'shirt1',
          note: '模特兒身高：185cm／穿著XL尺寸<br />※未標示的商品僅為拍攝搭配參考商品。',
          products: [
            {
              id: 1,
              current_index: 1,
              no_chips: false,
              tag: '',
              items: [
                '4548076088271',
                '4548076088332',
                '4548076088394',
                '4548076088547',
                '4548076088608',
                '4548076088660',
              ],
            },
          ],
          sub: ['shirt1-sub1', 'shirt1-sub2'],
        },
      },
      {
        id: 2,
        pickup: {
          align: 'right',
          main: 'shirt2',
          note: '模特兒身高：185cm／穿著XL尺寸<br />※未標示的商品僅為拍攝搭配參考商品。',
          products: [
            {
              id: 1,
              current_index: 2,
              no_chips: false,
              tag: '',
              items: [
                '4548076087076',
                '4548076087137',
                '4548076087199',
                '4548076087250',
                '4548076087342',
                '4548076087403',
              ],
            },
          ],
          sub: ['shirt2-sub1', 'shirt2-sub2'],
        },
        snap: [
          {
            id: 1,
            name: '男亞麻水洗立領長袖襯衫',
            number: '7522227',
            modelInfo: '模特身高：183cm／穿著L尺寸',
          },
        ],
      },
      {
        id: 3,
        pickup: {
          align: 'left',
          main: 'shirt3',
          note: '模特兒身高：185cm／穿著L尺寸<br />※未標示的商品僅為拍攝搭配參考商品。',
          products: [
            {
              id: 1,
              current_index: 1,
              no_chips: false,
              tag: '',
              items: ['4548076089117', '4548076089209', '4548076089261', '4548076089353'],
            },
          ],
          sub: ['shirt3-sub1', 'shirt3-sub2'],
        },
      },
    ],
  },
  {
    id: 2,
    name: 'outer',
    heading: '外套',
    items: [
      {
        id: 1,
        pickup: {
          align: 'right',
          main: 'outer',
          note: '模特兒身高：181cm／穿著L尺寸<br />※未標示的商品僅為拍攝搭配參考商品。',
          products: [
            {
              id: 1,
              current_index: 2,
              no_chips: false,
              tag: '',
              items: ['4548076069768', '4548076069829', '4548076069881'],
            },
          ],
          sub: ['outer-sub1', 'outer-sub2'],
        },
        snap: [
          {
            id: 1,
            name: '男亞麻水洗外套',
            number: '7522244',
            modelInfo: '模特身高：183cm／穿著L尺寸',
          },
        ],
      },
    ],
  },
  {
    id: 3,
    name: 'cardigan',
    heading: '開襟衫・針織衫',
    items: [
      {
        id: 1,
        pickup: {
          align: 'left',
          main: 'cardigan',
          note: '模特兒身高：185cm／穿著L尺寸<br />※未標示的商品僅為拍攝搭配參考商品。',
          products: [
            {
              id: 1,
              current_index: 2,
              no_chips: false,
              tag: '',
              items: ['4548076753810', '4548076753872', '4548076753933'],
            },
          ],
          sub: ['cardigan-sub1', 'cardigan-sub2'],
        },
        snap: [
          {
            id: 1,
            name: '男亞麻混長袖針織襯衫式開襟衫',
            number: '7522408',
            modelInfo: '模特身高：184cm／穿著L尺寸',
          },
        ],
      },
      {
        id: 2,
        pickup: {
          align: 'right',
          main: 'sweater',
          note: '模特兒身高：185cm／穿著L尺寸<br />※未標示的商品僅為拍攝搭配參考商品。',
          products: [
            {
              id: 1,
              current_index: 3,
              no_chips: false,
              tag: '',
              items: ['4548076755203', '4548076755272', '4548076755333', '4548076755395'],
            },
          ],
          sub: ['sweater-sub1', 'sweater-sub2'],
        },
        snap: [
          {
            id: 1,
            name: '男亞麻混圓領短袖針織衫',
            number: '7522227',
            modelInfo: '模特身高：183cm／穿著L尺寸',
          },
          {
            id: 2,
            name: '男亞麻混圓領短袖針織衫',
            number: '7522407',
            modelInfo: '模特身高：184cm／穿著L尺寸',
          },
        ],
      },
    ],
  },
  {
    id: 4,
    name: 'pants',
    heading: '褲子',
    items: [
      {
        id: 1,
        pickup: {
          align: 'left',
          main: 'pants',
          note: '模特兒身高：184cm／穿著L尺寸<br />※未標示的商品僅為拍攝搭配參考商品。',
          products: [
            {
              id: 1,
              current_index: 0,
              no_chips: false,
              tag: '',
              items: ['4548076128182', '4548076128243', '4548076128304'],
            },
          ],
          sub: ['pants-sub1', 'pants-sub2'],
        },
        snap: [
          {
            id: 1,
            name: '男亞麻水洗錐形褲',
            number: '7522408',
            modelInfo: '模特身高：184cm／穿著L尺寸',
          },
          {
            id: 2,
            name: '男亞麻水洗錐形褲',
            number: '7522407',
            modelInfo: '模特身高：184cm／穿著L尺寸',
          },
          {
            id: 3,
            name: '男大麻混棉斜紋織直筒褲',
            number: '7522227',
            modelInfo: '模特身高：183cm／穿著L尺寸',
          },
          {
            id: 4,
            name: '男大麻混棉斜紋織直筒褲',
            number: '7522405',
            modelInfo: '模特身高：184cm／穿著L尺寸',
          },
          {
            id: 5,
            name: '男大麻混丹寧直筒褲',
            number: '7522406',
            modelInfo: '模特身高：184cm／穿著L尺寸',
          },
        ],
      },
    ],
  },
];

export const menLineupData = {
  products: [
    {
      id: 1,
      current_index: 2,
      no_chips: false,
      tag: '',
      items: ['4548076088271', '4548076088332', '4548076088394', '4548076088547', '4548076088608', '4548076088660'],
    },
    {
      id: 2,
      current_index: 1,
      no_chips: false,
      tag: '',
      items: ['4548076087076', '4548076087137', '4548076087199', '4548076087250', '4548076087342', '4548076087403'],
    },
    {
      id: 3,
      current_index: 1,
      no_chips: false,
      tag: '',
      items: ['4548076089117', '4548076089209', '4548076089261', '4548076089353'],
    },
    {
      id: 4,
      current_index: 2,
      no_chips: false,
      tag: '',
      items: ['4548076753810', '4548076753872', '4548076753933'],
    },
    {
      id: 5,
      current_index: 0,
      no_chips: false,
      tag: '',
      items: ['4548076069768', '4548076069829', '4548076069881'],
    },
    {
      id: 6,
      current_index: 0,
      no_chips: false,
      tag: '',
      items: ['4548076128182', '4548076128243', '4548076128304'],
    },
    {
      id: 7,
      current_index: 0,
      no_chips: false,
      tag: '',
      items: ['4548076895466'],
    },
    {
      id: 8,
      current_index: 0,
      no_chips: false,
      tag: '',
      items: ['4548076128861', '4548076128922', '4548076128984'],
    },
  ],
};

export const storiesData = [
  {
    id: 1,
    link: 'https://www.muji.tw/tw/pdf/',
    img: 'story01.jpg',
    text: '穿搭型錄',
  },
  {
    id: 2,
    link: 'https://www.muji.tw/tw/feature/26ss/mujilabo-spring/',
    img: 'story02.jpg',
    text: '2026 MUJI Labo Spring&Summer',
  },
  {
    id: 3,
    link: 'https://www.muji.tw/tw/feature/26ss/saratto-inner/',
    img: 'story03.jpg',
    text: '宛如肌膚般 清爽舒適｜清爽舒適棉內衣',
  },
  {
    id: 4,
    link: 'https://shop.muji.tw/sb/style/',
    img: 'story04.jpg',
    text: 'Styling Advisor 穿搭圖輯',
  },
  {
    id: 5,
    link: 'https://www.muji.tw/tw/feature/24aw/socks/',
    img: 'story05.jpg',
    text: '365天都想穿的襪款',
  },
  {
    id: 6,
    link: 'https://www.muji.tw/tw/styling_advisor/',
    img: 'story06.jpg',
    text: '服飾搭配諮詢服務',
  },
];
